export default "__VITE_ASSET__ea83369c__"